import type { MessageKey } from '../en';

export const it: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "Precisione usata per i nuovi punti della cronologia",
  "defaults.accuracy.title": "Precisione GPS predefinita",
  "defaults.actual.desc": "Usata per cercare luoghi durante la simulazione",
  "defaults.actual.empty": "Non ancora salvata",
  "defaults.actual.emptyHint": "Consenti la posizione e apri l'app senza simulazione per acquisirla.",
  "defaults.actual.pending": "Il telefono salva questa posizione. Il sync non è ancora connesso.",
  "defaults.actual.refresh": "Aggiorna ora",
  "defaults.actual.title": "La tua posizione reale",
  "defaults.browserChip": "Questo browser",
  "defaults.close": "Chiudi",
  "defaults.color.desc": "Colore della linea dei nuovi percorsi",
  "defaults.color.group": "Colore del percorso",
  "defaults.color.title": "Colore del percorso",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "Data, anno · 12 h",
  "defaults.format.dayShort": "Giorno e data · 12 h",
  "defaults.format.eu": "Data UE · 24 h",
  "defaults.format.fullDay": "Data completa · 12 h",
  "defaults.format.iso": "Data ISO · 24 h",
  "defaults.format.monthFirst": "Mese prima · 24 h",
  "defaults.format.shortDayYear": "Giorno, data, anno · 24 h",
  "defaults.format.timeFirst": "Ora prima · 24 h",
  "defaults.format.us": "Data USA · 12 h",
  "defaults.format.withSeconds": "Con secondi · 12 h",
  "defaults.itinAccuracy.desc": "Precisione GPS dei nuovi tratti",
  "defaults.itinAccuracy.title": "Precisione",
  "defaults.itinerary.desc": "Valori predefiniti per i nuovi tratti",
  "defaults.itinerary.title": "Percorso",
  "defaults.joyAccuracy.desc": "Precisione GPS iniziale alla creazione di una sessione joystick",
  "defaults.joyAccuracy.title": "Precisione GPS predefinita",
  "defaults.joyName.desc": "Nome predefinito delle nuove sessioni joystick",
  "defaults.joyName.dialogTitle": "Scegli il formato del nome della sessione",
  "defaults.joyName.title": "Formato data",
  "defaults.joySpeed.desc": "Velocità iniziale alla creazione di una sessione joystick",
  "defaults.joySpeed.title": "Velocità predefinita",
  "defaults.joyUnit.desc": "Mostra e regola le velocità del joystick in km/h o mph",
  "defaults.joystick.desc": "Valori predefiniti per le sessioni joystick",
  "defaults.joystick.title": "Joystick",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "Come si aprono le nuove mappe",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "Aspetto delle nuove schermate mappa",
  "defaults.mapTheme.group": "Tema mappa",
  "defaults.mapTheme.title": "Tema mappa",
  "defaults.marker.car": "Auto",
  "defaults.marker.desc": "Usato alla creazione di una sessione joystick. Puoi cambiarlo per ogni sessione.",
  "defaults.marker.group": "Indicatore predefinito",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "Indicatore predefinito",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "Nome predefinito dei punti fissi",
  "defaults.nameFormat.dialogSubtitle": "L'anteprima usa la data di oggi. Scegli un formato compatto per i nuovi punti.",
  "defaults.nameFormat.dialogTitle": "Scegli il formato del nome del punto",
  "defaults.nameFormat.group": "Formato data",
  "defaults.nameFormat.title": "Formato data",
  "defaults.overlay.itinerary.desc": "Player flottante quando la simulazione del percorso continua in background",
  "defaults.overlay.itinerary.title": "Percorso automatico",
  "defaults.overlay.joystick.desc": "Joystick flottante quando la sessione continua in background",
  "defaults.overlay.joystick.title": "Joystick",
  "defaults.overlay.playlist.desc": "Player flottante quando la simulazione della lista continua in background",
  "defaults.overlay.playlist.title": "Lista",
  "defaults.overlay.stationary.desc": "Player flottante quando la simulazione fissa continua in background",
  "defaults.overlay.stationary.title": "Punto fisso",
  "defaults.plAccuracy.desc": "Precisione GPS applicata a ogni pin della lista",
  "defaults.plAccuracy.title": "Precisione per elemento",
  "defaults.player.desc": "Controlli del player in overlay e della simulazione",
  "defaults.player.title": "Player",
  "defaults.playlist.desc": "Valori predefiniti per i nuovi pin della lista",
  "defaults.playlist.title": "Lista",
  "defaults.polyline.desc": "Colore predefinito del percorso disegnato durante una sessione joystick.",
  "defaults.polyline.group": "Colore della polilinea",
  "defaults.polyline.title": "Colore predefinito della polilinea",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 s",
  "defaults.range.timeMin": "0 s",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "Reimposta",
  "defaults.search.itinerary": "I risultati vicini al centro della mappa hanno priorità",
  "defaults.search.playlist": "I risultati vicini al centro della mappa hanno priorità",
  "defaults.search.stationary": "I risultati vicini al pin hanno priorità",
  "defaults.search.title": "Raggio di ricerca",
  "defaults.seconds": "{n} s",
  "defaults.section.appearance": "Aspetto",
  "defaults.section.camera": "Fotocamera",
  "defaults.section.history": "Cronologia",
  "defaults.section.location": "Contesto posizione",
  "defaults.section.map": "Mappa",
  "defaults.section.motion": "Movimento",
  "defaults.section.overlay": "Player in overlay",
  "defaults.section.playlist": "Lista",
  "defaults.section.search": "Ricerca",
  "defaults.section.style": "Stile",
  "defaults.section.view": "Mappa",
  "defaults.sectionDefaults": "Valori predefiniti dell'app",
  "defaults.sectionDefaultsDesc": "Imposta valori predefiniti per un'esperienza più rapida e fluida",
  "defaults.sectionPlayer": "Player",
  "defaults.sectionPlayerDesc": "Impostazioni di overlay e riproduzione",
  "defaults.speed.desc": "Velocità di riproduzione dei nuovi tratti",
  "defaults.speed.title": "Velocità predefinita",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "Valori predefiniti per i nuovi punti sulla mappa",
  "defaults.stationary.title": "Punto fisso",
  "defaults.summary.playerAll": "Tutti gli overlay attivi",
  "defaults.summary.playerOff": "Overlay disattivati",
  "defaults.summary.playerSome": "{on} su 4 attivi",
  "defaults.summary.zoom": "zoom {n}",
  "defaults.syncNote": "Salvato in questo browser per ora. L'app del telefono userà questi valori quando il sync sarà connesso.",
  "defaults.theme.night": "Notte",
  "defaults.theme.nightDesc": "Colori scuri della mappa per poca luce e sessioni notturne.",
  "defaults.theme.retro": "Retrò",
  "defaults.theme.retroDesc": "Toni caldi d'epoca, con aria di mappa classica.",
  "defaults.theme.silver": "Argento",
  "defaults.theme.silverDesc": "Stile grigio chiaro, piacevole di giorno.",
  "defaults.theme.standard": "Standard",
  "defaults.theme.standardDesc": "Colori classici di Google Maps, con verdi e blu familiari.",
  "defaults.tilt.desc": "Angolo della fotocamera nelle schermate mappa",
  "defaults.tilt.title": "Inclinazione predefinita della fotocamera",
  "defaults.time.desc": "Attesa prima di passare al pin successivo",
  "defaults.time.title": "Tempo per elemento",
  "defaults.tray.group": "Altezza del riquadro",
  "defaults.tray.large": "Grande",
  "defaults.tray.medium": "Media",
  "defaults.tray.playlistDesc": "Pannello liste visibile sulla mappa",
  "defaults.tray.small": "Piccola",
  "defaults.tray.stationaryDesc": "Dimensione visibile del pannello sulla mappa",
  "defaults.tray.title": "Altezza del riquadro",
  "defaults.unit.group": "Unità di velocità",
  "defaults.unit.itineraryDesc": "Mostra le velocità in km/h o mph nel modulo percorso",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "Unità di velocità",
  "defaults.view.grid": "Griglia",
  "defaults.view.group": "Vista",
  "defaults.view.historyDesc": "Come vengono mostrati i punti salvati",
  "defaults.view.historyTitle": "Vista cronologia",
  "defaults.view.list": "Elenco",
  "defaults.view.playlistDesc": "Come vengono mostrate le liste salvate",
  "defaults.view.playlistTitle": "Vista liste",
  "defaults.zoom.desc": "Zoom iniziale delle nuove mappe",
  "defaults.zoom.title": "Livello di zoom predefinito",
  "language.defaultBadge": "Predefinita",
  "language.empty": "Nessuna lingua corrisponde a questa ricerca.",
  "language.lead": "Inglese (Stati Uniti) è la lingua predefinita. La scelta resta salvata in questo browser.",
  "language.listLabel": "Lingue",
  "language.preview": "Posizioni simulate, liste e percorsi.",
  "language.previewLabel": "Anteprima",
  "language.searchLabel": "Cerca lingue",
  "language.searchPlaceholder": "Cerca lingue",
  "nav.account": "Account",
  "nav.account.desc": "Profilo, Premium e accesso.",
  "nav.analytics": "Analisi",
  "nav.analytics.desc": "Comprendi attività MockLoc, uso della rete e stato del sync.",
  "nav.articles": "Articoli",
  "nav.articles.desc": "Guide su configurazione, riproduzione e sync.",
  "nav.backup": "Backup e sync",
  "nav.backup.desc": "Stato del backup nel cloud e della sincronizzazione.",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "Dettaglio completo dell'uso delle monete per modulo e attività.",
  "nav.dashboard": "Panoramica",
  "nav.dashboard.desc": "Riepilogo di posizioni, liste, percorsi e attività dell'account.",
  "nav.devices": "Gestisci dispositivi",
  "nav.devices.desc": "Controlla i dispositivi connessi al tuo account MockLoc.",
  "nav.help": "Aiuto e supporto",
  "nav.help.desc": "Segui le conversazioni e chiedi aiuto al team MockLoc.",
  "nav.history": "Cronologia posizioni",
  "nav.history.desc": "Luoghi simulati da questo account.",
  "nav.itinerary": "Percorsi",
  "nav.itinerary.desc": "Crea, modifica e gestisci i percorsi salvati.",
  "nav.joystick": "Sessioni joystick",
  "nav.joystick.desc": "Percorsi di riproduzione, statistiche e sessioni joystick salvate.",
  "nav.notifications": "Notifiche",
  "nav.notifications.desc": "Avvisi di sync, backup e prodotto.",
  "nav.playlist": "Liste",
  "nav.playlist.desc": "Insiemi ordinati di posizioni simulate.",
  "nav.settings": "Impostazioni",
  "nav.settings.desc": "Tema, lingua e valori predefiniti dell'app mobile.",
  "nav.stationary": "Punti fissi",
  "nav.stationary.desc": "Posizioni simulate fisse salvate su questo account.",
  "nav.whatsNew": "Novità dell'app",
  "nav.whatsNew.desc": "Nuovi aggiornamenti, correzioni e miglioramenti in MockLoc.",
  "settings.back": "Impostazioni",
  "settings.backDefaults": "Valori predefiniti dell'app",
  "settings.defaults.shellDesc": "Valori usati dall'app del telefono per mappe, punti, percorsi e riproduzione.",
  "settings.defaults.shellTitle": "Valori predefiniti dell'app",
  "settings.home.defaults.desc": "Valori predefiniti di mappa, punto, lista, percorso, joystick e player dell'app del telefono.",
  "settings.home.defaults.title": "Valori predefiniti dell'app",
  "settings.home.language.desc": "Scegli la lingua di menu, titoli di pagina e impostazioni.",
  "settings.home.language.title": "Impostazioni lingua",
  "settings.home.theme.desc": "Dimensione del testo, colori, chiaro o scuro e carattere per questo browser.",
  "settings.home.theme.title": "Impostazioni tema",
  "settings.language.shellDesc": "Scegli la lingua di questo sito.",
  "settings.language.shellTitle": "Lingua",
  "settings.theme.shellDesc": "Dimensione del testo, colori, chiaro o scuro e carattere per questo browser.",
  "settings.theme.shellTitle": "Tema",
  "shell.account": "Account",
  "shell.accountMenu": "Menu account",
  "shell.accountMenuNamed": "Menu account, {name}",
  "shell.closeMenu": "Chiudi menu",
  "shell.collapseSidebar": "Comprimi barra laterale",
  "shell.dashboardSubtitle": "Gestisci posizioni simulate, liste, percorsi e altro in un unico posto.",
  "shell.devicesLimit": "Uso su un massimo di 3 dispositivi",
  "shell.expandSidebar": "Espandi barra laterale",
  "shell.goPremium": "Passa a Premium",
  "shell.logOut": "Esci",
  "shell.mainNav": "Navigazione principale",
  "shell.noMatches": "Nessun risultato",
  "shell.notifications": "Notifiche",
  "shell.notificationsUnread": "Notifiche, {count} non lette",
  "shell.openMenu": "Apri menu",
  "shell.pages": "Pagine",
  "shell.recent": "Recenti",
  "shell.searchLabel": "Cerca posizioni, liste, percorsi, articoli",
  "shell.searchPlaceholder": "Cerca posizioni, liste, percorsi, articoli...",
  "shell.searchResults": "Risultati della ricerca",
  "shell.tagline": "Posizione simulata, in modo semplice",
  "shell.themeDarkTitle": "Tema scuro",
  "shell.themeLightTitle": "Tema chiaro",
  "shell.themeToDark": "Passa al tema scuro",
  "shell.themeToLight": "Passa al tema chiaro",
  "shell.there": "tu",
  "shell.unlimitedCoins": "Monete illimitate",
  "shell.unlimitedEverything": "Tutto illimitato",
  "shell.upgradeNow": "Aggiorna ora",
  "shell.viewAllNotifications": "Vedi tutte le notifiche",
  "shell.welcome": "Bentornato, {name}!",
  "theme.builtin": "Integrato",
  "theme.changesLabel": "Cosa cambia.",
  "theme.color.accent.changes": "Oro del marchio e fondi oro pallido, anche i piccoli dettagli delle illustrazioni.",
  "theme.color.accent.title": "Accento",
  "theme.color.accent.where": "Accenti dorati su accesso, articoli e badge.",
  "theme.color.danger.changes": "Testo di errore rosso e azioni distruttive.",
  "theme.color.danger.title": "Pericolo",
  "theme.color.danger.where": "Errori, rimozioni e il punto dei non letti.",
  "theme.color.info.changes": "Il blu usato per le informazioni in chiaro e scuro.",
  "theme.color.info.title": "Info",
  "theme.color.info.where": "Stato blu, link informativi e segni info.",
  "theme.color.lead": "I colori integrati restano diversi in chiaro e scuro finché non ne scegli uno. La tua scelta vale in entrambi i temi. I colori salvati su un punto, una lista o un percorso restano quelli.",
  "theme.color.primary.changes": "Viola pieno, testo viola chiaro e fondi viola tenui.",
  "theme.color.primary.title": "Primario",
  "theme.color.primary.where": "Pulsanti, voce di menu attiva, link e viola del marchio.",
  "theme.color.success.changes": "Testo di stato verde e segni di successo.",
  "theme.color.success.title": "Successo",
  "theme.color.success.where": "Sincronizzato, completato e stato positivo.",
  "theme.color.title": "Colore",
  "theme.color.warning.changes": "Avvisi ambra e l'oro usato sulle monete.",
  "theme.color.warning.title": "Avviso",
  "theme.color.warning.where": "Avvisi, segni delle monete e accenti Premium.",
  "theme.colorAria": "Colore {title}",
  "theme.custom": "Personalizzato",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Sintetizzato da Arial",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica o sintetizzato",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular e Bold sono caratteri installati. Gli altri pesi sono sintetizzati.",
  "theme.font.google-sans.note": "Il file Regular copre 400 e 500. Il file Bold copre da 600 a 900.",
  "theme.font.group": "Carattere",
  "theme.font.helvetica.note": "Usa Helvetica su questo dispositivo, poi Helvetica Neue, poi Arial.",
  "theme.font.inter.note": "Carattere usato oggi dal sito. Da Regular a Black sono caricati.",
  "theme.font.lead": "Una sola famiglia vale per tutto il sito. I titoli marketing tornano a Plus Jakarta Sans quando è scelto Inter. I pesi sotto sono quelli che l'interfaccia usa già.",
  "theme.font.sample": "Posizione simulata, in modo semplice",
  "theme.font.title": "Carattere",
  "theme.hexAria": "Hex {title}",
  "theme.lead": "Scegli dimensione del testo, colore, chiaro o scuro e il carattere di questo browser. 100 % corrisponde alle schermate di oggi. Gli esempi qui, e il resto del sito, si aggiornano insieme.",
  "theme.manager": "Gestione tema",
  "theme.mode.dark": "Scuro",
  "theme.mode.darkHint": "Superfici scure e testo chiaro.",
  "theme.mode.group": "Tema",
  "theme.mode.lead": "La stessa scelta chiaro o scuro del pulsante nella barra in alto.",
  "theme.mode.light": "Chiaro",
  "theme.mode.lightHint": "Superfici chiare e testo scuro.",
  "theme.mode.title": "Tema",
  "theme.previewBody": "Posizioni salvate su questo account.",
  "theme.previewBold": "Lista pronta",
  "theme.previewHelp": "Insiemi ordinati di posizioni simulate.",
  "theme.previewKicker": "Anteprima live",
  "theme.previewTitle": "Posizioni simulate",
  "theme.reset": "Reimposta",
  "theme.resetAll": "Reimposta tutto",
  "theme.resetColors": "Reimposta colori",
  "theme.resetFont": "Reimposta carattere",
  "theme.resetText": "Reimposta testo",
  "theme.sizeAria": "Dimensione di {title}",
  "theme.text.bold.changes": "Testo da 15 px a 18 px.",
  "theme.text.bold.sample": "Passa a Premium",
  "theme.text.bold.title": "Grassetto",
  "theme.text.bold.where": "Titoli delle schede, nome del marchio, titoli di sezione e pulsanti grandi.",
  "theme.text.descriptive.changes": "Testo da 12 px a 13 px.",
  "theme.text.descriptive.sample": "Insiemi ordinati di posizioni simulate.",
  "theme.text.descriptive.title": "Descrittivo",
  "theme.text.descriptive.where": "Sottotitoli, testo di aiuto, badge, piè di pagina e righe secondarie.",
  "theme.text.header.changes": "Testo da 20 px in su.",
  "theme.text.header.sample": "Punti fissi",
  "theme.text.header.title": "Intestazione",
  "theme.text.header.where": "Titoli di pagina, titoli grandi, titoli di stato vuoto e numeri grandi come i saldi delle monete.",
  "theme.text.lead": "Ogni ruolo ha una dimensione condivisa. L'esempio mostra quel ruolo. I cursori di questa pagina restano di dimensione fissa per essere facili da usare.",
  "theme.text.normal.changes": "Testo a 14 px.",
  "theme.text.normal.sample": "Posizioni salvate su questo account.",
  "theme.text.normal.title": "Normale",
  "theme.text.normal.where": "Etichette di navigazione, pulsanti standard, titoli di elenco e brevi riassunti.",
  "theme.text.other.changes": "Testo da 9 px a 11 px. I segni sotto 9 px restano fissi.",
  "theme.text.other.sample": "Aggiornato 2 ore fa",
  "theme.text.other.title": "Altro",
  "theme.text.other.where": "Etichette piccole, orari, etichette dei grafici e didascalie.",
  "theme.text.title": "Testo",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "Posizioni simulate, liste e percorsi",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "Dove viene usato.",
};
